import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SidebarBtn from "../../components/header/btn/sidebar-btn";
import { useFetchProfile } from "../../api/signcard";
import Contact from "./component/contact";
import Header from "../../components/header/header";
import { QrBtn } from "../../components/header/btn/qr-btn";
import Swal from "sweetalert2";
import Sidebar from "../../components/sidebar";
import QrInfo from "../profile/component/qr-info"
import { ProfileStatus } from "./domain/profile-state";
import { Brboxiconbtn } from '../../components/btns/brboxiconbtn';

const initProfileInfo = {
    name: "알 수 없음",
    description: "알 수 없음",
    job: "알 수 없음",
    residence: "알 수 없음",
    profileImageUrl: null,
    backgroundImageUrl: null,
    contacts: []
}

function ProfilePage() {
    const { link } = useParams();
    const navigate = useNavigate();
    const [isOwner, setOwner] = useState(false)
    const [profileInfo, setProfileInfo] = useState(initProfileInfo);
    const [isLoading, fetchProfile, error] = useFetchProfile(link)
    const [isQrModalOpen, setQrModalOpen] = useState(false)
    const [isMenuOpen, setMenuOpen] = useState(false)

    useEffect(() => {
        const mapToProfileInfo = (profile) => ({
            name: profile.name || initProfileInfo.name,
            description: profile.description || initProfileInfo.description,
            job: profile.job || initProfileInfo.job,
            residence: profile.residence || initProfileInfo.residence,
            profileImageUrl: profile.profileImageUrl || initProfileInfo.profileImage,
            backgroundImageUrl: profile.backgroundImageUrl || initProfileInfo.backgroundImage,
            contacts: profile.contacts || initProfileInfo.contacts
        })


        if (fetchProfile == null) return
        setProfileInfo(mapToProfileInfo(fetchProfile))

        if (fetchProfile.status === ProfileStatus.NEED_UPDATE) {
            Swal.fire({
                title: '프로필 작성이 완료되지 않았어요!',
                text: '프로필을 작성해주세요.',
                customClass: 'swal-alert',
                allowOutsideClick: false,
                confirmButtonText: '확인',
                confirmButtonColor: '#2D2D2D'
            }).then(() => navigate(`/profile/${link}/edit`))
        } else {
            setOwner(fetchProfile.status === ProfileStatus.OWNER)
        }
    }, [fetchProfile])

    const renderProfileImg = () => profileInfo.profileImageUrl ?
        <img className='profile-image-preview' alt={""}
            src={`/api/profile/image?key=${profileInfo.profileImageUrl}`} /> :
        <div className="empty-pf" />

    const renderBackgroundImg = () => profileInfo.backgroundImageUrl ?
        <img className='profile-bg-preview'
            src={`/api/profile/image?key=${profileInfo.backgroundImageUrl}`} /> :
        <div className="empty-bg" />

    const ProfileSaveBtn = () => {
        return <>
            <div className='profile-btn-container'>
                <a href={`/api/profile/${link}/download`}
                    className="profile-btn purple">
                    <span className="profile-btn-text">저장하기</span>
                    <div className="profile-icon-wrapper">
                        <img src="/assets/icons/download-icon.svg" />
                    </div>

                </a>
            </div>
        </>
    }

    const ProfileEditBtn = () => {
        const goToEdit = () => navigate(`/profile/${link}/edit`)
        return <>
            <div className='profile-btn-container'>
                <button type="submit" className={`profile-btn green`} onClick={goToEdit}>
                    <span className="profile-btn-text">편집하기</span>
                    <div className="profile-icon-wrapper">
                        <img src={`/assets/icons/edit-btn-icon.svg`} />
                    </div>
                </button>
            </div>
        </>
    }

    const ContactComponents = () => profileInfo.contacts.map((contact, index) => {
        return <Contact key={index} contact={contact} />
    });

    const openQrModal = () => setQrModalOpen(true)
    const closeQrModal = () => setQrModalOpen(false)

    const openMenu = () => setMenuOpen(true);

    const closeMenu = () => setMenuOpen(false);

    if (isLoading || error || fetchProfile.status === ProfileStatus.NEED_UPDATE) {
        return <></>
    }

    return (
        <>
            <div className="Layer profile">
                <Header fixed={true}>
                    <SidebarBtn open={openMenu} />
                    {isOwner && <QrBtn open={openQrModal} />}
                </Header>
                <div className='Layer-inner'>
                    <div className="profile-bg">
                        {renderBackgroundImg()}
                    </div>

                    <div className="contents-container">
                        <div className="profile-image">
                            {renderProfileImg()}
                        </div>
                        <div className="profile-container">
                            <div className="user-info">
                                <div className="user-name" id="name">{profileInfo.name} </div>
                                <div className="user-desc hidden" id="desc">
                                    <p>
                                        {profileInfo.description}
                                    </p></div>
                                <ul className="profile-list">
                                    <li className="profile-job" id="job"> {profileInfo.job} </li>
                                    <li className="profile-residence"> {profileInfo.residence} </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='grid-wrapper'>
                        <div className='grid-bg'></div>
                        <div className="contact-container">
                            <ContactComponents />
                            <div className="empty-content-wrapper" />
                        </div>
                    </div>
                    <div className="bottom-gradient"></div>

                    {isOwner ? <ProfileEditBtn /> : <ProfileSaveBtn />}

                </div>
            </div>
            {/* {isOwner ? <QrInfo isOpen={isQrModalOpen} name={profileInfo.name} description={profileInfo.description} close={closeQrModal} /> : ""} */}
            {isOwner ? <QrInfo isOpen={isQrModalOpen} name={profileInfo.name} description={profileInfo.description} link={link} close={closeQrModal} /> : <div style={{ visibility: "hidden" }}></div>}
            <Sidebar isOpen={isMenuOpen} close={closeMenu} />
        </>
    )
}

export default ProfilePage;
